// extracted by mini-css-extract-plugin
export default {"commentsContainer":"PostComments_commentsContainer__fVVyg","commentsList":"PostComments_commentsList__Y9poM","hideComments":"PostComments_hideComments__k3Byk"};